import type { ExcelImportFieldStatus, ExcelImportResponse } from '../../../model/kartera-api-model'

export { errorMessage, formatCount, pageWindow, RamoMark } from '../../customers/common/customer-common'

export const POLICY_IMPORT_PATH = '/importar-polizas'
export const POLICY_IMPORT_PDF_PATH = `${POLICY_IMPORT_PATH}/pdf`
export const POLICY_IMPORT_EXCEL_PATH = `${POLICY_IMPORT_PATH}/excel`
export const POLICY_IMPORT_EXCEL_RESULT_PATH = `${POLICY_IMPORT_PATH}/excel-result`
export const AGENT_KEYS_PATH = '/claves'

export const policyEditPath = (id: number) => `/polizas/${id}/edit`

/** `state` con el que la pantalla de Excel abre la de resultados. */
export interface ExcelResultLocationState {
    polizas?: ExcelImportResponse[]
}

export const STATUS_TONES: Record<ExcelImportFieldStatus, string> = {
    ok: 'text-k-ink-2',
    warning: 'text-tone-orange-ink',
    error: 'text-k-danger-ink',
}

export const statusOf = (value?: string | null): ExcelImportFieldStatus => (value === 'error' || value === 'warning' ? value : 'ok')
